/* eslint-disable */
export const CameraAssetFilters = [
    {label: 'Function', value: 'function'},
    {label: 'Area', value: 'area'},
    {label: 'View', value: 'view'}
]
export const DefaultSBLocationStr = "Plaza"
export const DefaultCenter = "Port Hope"